export const authenticationCookie: string = 'vlaio.authenticated';
export const savedKBOCookie: string = 'vlaio.savedKBO';
